/* retropac-article : bouton "copier le lien" de partage */
document.querySelectorAll('.rp-article__copy').forEach(function (copyBtn) {
  if (!navigator.clipboard) return;
  copyBtn.addEventListener('click', function () {
    navigator.clipboard.writeText(copyBtn.dataset.copy).then(function () {
      copyBtn.classList.add('is-copied');
      setTimeout(function () { copyBtn.classList.remove('is-copied'); }, 1500);
    });
  });
});
